import type { Environment } from 'src/types';

export const isEnvDev = (env: Environment) => env === 'dev';
export const isEnvStaging = (env: Environment) => env === 'staging';
export const isEnvProd = (env: Environment) => env === 'production';
